const swatches = {
    zloty: 'gold', srebrny: 'silver', czarny: 'black',
    'rozowe-zloto': 'rose', 'brudny-roz': 'rose', 'brudna-roza': 'rose', rozowy: 'rose',
};

/** Visual samples use the existing brand assets; labels remain catalog data. */
export const metalSwatch = (value) => {
    const key = String(value).toLowerCase().replaceAll('ł', 'l').normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '').replace(/\s+/g, '-');
    return swatches[key] || null;
};
